import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=79607496&scoped=true&"
import script from "./SaleDetails.vue?vue&type=script&lang=js&"
export * from "./SaleDetails.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=79607496&prod&lang=css&"
import style1 from "./SaleDetails.vue?vue&type=style&index=1&id=79607496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79607496",
  null
  
)

export default component.exports